import { append } from './DOM';
import Scroll from '../vendor/scroll-js';


const scroll = new Scroll(document.body);
const SCROLL_OPTIONS = {
	easing: 'easeInCubic',
};


export const getOption = (option) => window.App ? window.App.options[option] : null;

export const loadScript = (url, callback) => {
	const script = document.createElement('script');

	script.src = url;
	script.onload = callback;
	append(script, document.body);
};

export const iconSVG = (id, classes = '') => {
	const ICONS_PATH = getOption('iconsPath') || '/img/bg/';


	return `<span class="icon-svg icon-svg--${id} ${classes}">
		<svg class="icon-svg__svg" xmlns:xlink="http://www.w3.org/1999/xlink">
			<use xlink:href="${ICONS_PATH}icons-svg.svg#icon-${id}" x="0" y="0" width="100%" height="100%"></use>
		</svg>
	</span>`;
};

export const scrollTo = (target, isMobile) => {
	if (isMobile) {
		const scrolled = document.documentElement.scrollTop || document.body.scrollTop || 0;
		const header = document.querySelector('.header');
		let offset = target.getBoundingClientRect().top + window.pageYOffset;
		const isScrollingUp = scrolled - offset > 0;


		if (isScrollingUp) {
			offset -= header.clientHeight;

			return scroll.to(0, offset, SCROLL_OPTIONS);
		}
	}

	return scroll.toElement(target, SCROLL_OPTIONS);
};

export const wrap = (element, wrapper) => {
	element.parentNode.insertBefore(wrapper, element);
	wrapper.appendChild(element);
};

export const unwrap = (element) => {
	const wrapper = element.parentNode;
	const parent = wrapper.parentNode;
	parent.insertBefore(element, wrapper);
	parent.removeChild(wrapper);
};

export const scrollTop = () => {
	return typeof window.pageYOffset !== 'undefined' ? window.pageYOffset : document.documentElement.scrollTop ? document.documentElement.scrollTop : document.body.scrollTop ? document.body.scrollTop : 0;
};



// WEBPACK FOOTER //
// ./src/js/tools/utils.js